/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecondaryMaterial } from '../../models/secondary-material';

export interface GetSecondaryMaterial$Params {
  workCenterId: number;
}

export function getSecondaryMaterial(http: HttpClient, rootUrl: string, params: GetSecondaryMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<SecondaryMaterial>> {
  const rb = new RequestBuilder(rootUrl, getSecondaryMaterial.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecondaryMaterial>;
    })
  );
}

getSecondaryMaterial.PATH = '/api/v1/SecondaryMaterial/{workCenterId}';
